interface HeadDataProps {
	description: string;
	title: string;
	url: string;
}
export const headData: HeadDataProps = {
	description: "project 42",
	title: "project 42",
	url: "http://project42.abclab.kr/"
};
